import { Logger, withTimeout } from '@streamr/utils';
import haversine from 'haversine';

/* eslint-disable */
const airportCodeToRegion = {
    JFK: [100, 40.639447, -73.779317],
    LGA: [200, 40.777199, -73.872597],
    EWR: [300, 40.692501, -74.168701],
    BUF: [400, 42.94049835, -78.73220062],
    BFI: [500, 47.529999, -122.302002],
    SEA: [600, 47.449162, -122.311134],
    PDX: [700, 45.58869934, -122.5979996],
    HIO: [800, 45.540401, -122.949997],
    SMF: [900, 38.69540023803711, -121.59100341796875],
    SFO: [1000, 37.61899948120117, -122.375],
    PAO: [1100, 37.461101532, -122.114997864],
    SJC: [1200, 37.362452, -121.929188],
    WVI: [1300, 36.9356994629, -121.790000916],
    BUR: [1400, 34.197703, -118.356378],
    LAX: [1500, 33.942501, -118.407997],
    SAN: [1600, 32.7336006165, -117.190002441],
    LAS: [1700, 36.083361, -115.151817],
    PHX: [1800, 33.435302, -112.005905],
    ABQ: [1900, 35.040199, -106.609001],
    DEN: [2000, 39.861698150635, -104.672996521],
    SLC: [2100, 40.785749, -111.979746],
    STP: [2200, 44.93479, -93.060036],
    MSP: [2300, 44.882, -93.221802],
    FSD: [2400, 43.585463, -96.741152],
    OMA: [2500, 41.3032, -95.894096],
    MCI: [2600, 39.2976, -94.713898],
    OKC: [2700, 35.393101, -97.6007],
    ADS: [2800, 32.9686012268, -96.8364028931],
    DFW: [2900, 32.896801, -97.038002],
    IAH: [3000, 29.984399795532227, -95.34140014648438],
    AUS: [3100, 30.197535, -97.662015],
    SAT: [3200, 29.533701, -98.469803],
    MFE: [3300, 26.176141, -98.237965],
    HNL: [3400, 21.32062, -157.924228],
    ANC: [3500, 61.1744, -149.996002],
    BOS: [3600, 42.3643, -71.005203],
    BGR: [3700, 44.8074, -68.828102],
    YTO: [3800, 43.6772, -79.6306],
    YYZ: [3900, 43.6772, -79.6306],
    YOW: [4000, 45.322498, -75.669197],
    YUL: [4100, 45.4706, -73.740799],
    YHZ: [4200, 44.8807983398, -63.5085983276],
    YVR: [4300, 49.193901062, -123.183998108],
    YYC: [4400, 51.113899231, -114.019996643],
    YXE: [4500, 52.170799255371094, -106.69999694824219],
    YWG: [4600, 49.909999847399995, -97.2398986816],
    KEF: [4700, 63.985001, -22.6056],
    DUB: [4800, 53.428713, -6.262121],
    ORK: [4900, 51.841301, -8.49111],
    MAN: [5000, 53.349375, -2.279521],
    LHR: [5100, 51.4706, -0.461941],
    LON: [5200, 51.4706, -0.461941],
    LCY: [5300, 51.505299, 0.055278],
    EDI: [5400, 55.950145, -3.372288],
    BRU: [5500, 50.901402, 4.48444],
    AMS: [5600, 52.308601, 4.76389],
    DUS: [5700, 51.289501, 6.76678],
    FRA: [5800, 50.036521, 8.561268],
    WIE: [5900, 50.049800872802734, 8.325400352478027],
    STR: [6000, 48.689899, 9.22196],
    MUC: [6100, 48.353802, 11.7861],
    TXL: [6200, 52.362247, 13.500672],
    HAM: [6300, 53.630402, 9.98823],
    LUX: [6400, 49.6233333, 6.2044444],
    DLP: [6500, 49.012798, 2.55],
    CDG: [6600, 49.012798, 2.55],
    PAR: [6700, 49.012798, 2.55],
    BOD: [6800, 44.8283, -0.715556],
    MRS: [6900, 43.438088, 5.2125],
    LYS: [7000, 45.725556, 5.081111],
    GVA: [7100, 46.238098, 6.10895],
    ZRH: [7200, 47.458056, 8.548056],
    MXP: [7300, 45.6306, 8.72811],
    LIN: [7400, 45.445099, 9.27674],
    FCO: [7500, 41.804532, 12.251998],
    PMO: [7600, 38.175999, 13.091],
    PRG: [7700, 50.103514, 14.256992],
    CPH: [7800, 55.617900848389, 12.656000137329],
    OSL: [7900, 60.193901, 11.1004],
    ARN: [8000, 59.651901245117, 17.918600082397],
    BMA: [8100, 59.354400634765625, 17.941699981689453],
    GOT: [8200, 57.662799835205, 12.279800415039],
    RIX: [8300, 56.923599, 23.9711],
    TLL: [8400, 59.41329956049999, 24.832799911499997],
    HEL: [8500, 60.3172, 24.963301],
    LED: [8600, 59.80030059814453, 30.262500762939453],
    KLD: [8700, 56.82469940185547, 35.7577018737793],
    DME: [8800, 55.40879821777344, 37.90629959106445],
    SVX: [8900, 56.743099212646, 60.802700042725],
    KJA: [9000, 56.173077, 92.492437],
    KHV: [9100, 48.528338, 135.188588],
    MSQ: [9200, 53.888071, 28.039964],
    VNO: [9300, 54.634102, 25.285801],
    WAW: [9400, 52.1656990051, 20.967100143399996],
    KBP: [9500, 50.345001, 30.894699],
    KIV: [9600, 46.9277, 28.931],
    OTP: [9700, 44.572127, 26.103396],
    IST: [9800, 41.261297, 28.741951],
    ADB: [9900, 38.2924, 27.157],
    ATH: [10000, 37.936401, 23.9445],
    SKG: [10100, 40.51928, 22.970009],
    SOF: [10200, 42.696357, 23.417671],
    TIA: [10300, 41.4147, 19.7206],
    BEG: [10400, 44.818401, 20.309099],
    BUD: [10500, 47.43018, 19.262393],
    BTS: [10600, 48.1702, 17.2127],
    VIE: [10700, 48.110298, 16.5697],
    ZAG: [10800, 45.742901, 16.0688],
    TUN: [10900, 36.851002, 10.2272],
    AAE: [11000, 36.826781, 7.81334],
    ALG: [11100, 36.693886, 3.214531],
    ORN: [11200, 35.623901, -0.621183],
    MAD: [11300, 40.471926, -3.56264],
    BCN: [11400, 41.2971, 2.07846],
    LIS: [11500, 38.7813, -9.13592],
    CMN: [11600, 33.3675, -7.58997],
    DKR: [11700, 14.7397, -17.4902],
    OUA: [11800, 12.3532, -1.51242],
    ACC: [11900, 5.605189800262451, -0.16678600013256073],
    LOS: [12000, 6.5773701667785645, 3.321160078048706],
    FIH: [12100, -4.38575, 15.4446],
    LAD: [12200, -8.85837, 13.2312],
    CPT: [12300, -33.9648017883, 18.6016998291],
    DUR: [12400, -29.6144444444, 31.1197222222],
    JNB: [12500, -26.1392, 28.246],
    MPM: [12600, -25.920799, 32.572601],
    GBE: [12700, -24.555201, 25.9182],
    HRE: [12800, -17.931801, 31.0928],
    TNR: [12900, -18.7969, 47.478802],
    RUN: [13000, -20.890087, 55.518894],
    MRU: [13100, -20.430201, 57.683601],
    DAR: [13200, -6.87811, 39.202599],
    MBA: [13300, -4.03483, 39.5942],
    NBO: [13400, -1.31923997402, 36.9277992249],
    KGL: [13500, -1.96863, 30.1395],
    JIB: [13600, 11.5473, 43.1595],
    CAI: [13700, 30.111534, 31.396694],
    TLV: [13800, 32.011398, 34.8867],
    HFA: [13900, 32.80939865112305, 35.04309844970703],
    ZDM: [14000, 31.91123, 35.20756],
    AMM: [14100, 31.7226009369, 35.9931983948],
    BEY: [14200, 33.820899963378906, 35.488399505615234],
    LCA: [14300, 34.875099, 33.624901],
    EVN: [14400, 40.1473007202, 44.3959007263],
    TBS: [14500, 41.669201, 44.9547],
    GYD: [14600, 40.467498779296875, 50.04669952392578],
    LLK: [14700, 38.757919, 48.807042],
    EBL: [14800, 36.23759841918945, 43.963199615478516],
    ISU: [14900, 35.5617485046, 45.316738128699996],
    BGW: [15000, 33.262501, 44.2346],
    NJF: [15100, 31.989853, 44.404317],
    XNH: [15200, 30.935801, 46.090099],
    BSR: [15300, 30.549101, 47.662102],
    KWI: [15400, 29.226601, 47.968899],
    RUH: [15500, 24.9576, 46.698799],
    DMM: [15600, 26.471200942993164, 49.79790115356445],
    JED: [15700, 21.6796, 39.156502],
    BAH: [15800, 26.267295, 50.63764],
    DOH: [15900, 25.273056, 51.608056],
    DXB: [16000, 25.2527999878, 55.3643989563],
    FJR: [16100, 25.1122, 56.324001],
    MCT: [16200, 23.593299865722656, 58.284400939941406],
    MLE: [16300, 4.191830158233643, 73.52909851074219],
    CMB: [16400, 7.180759906768799, 79.88410186767578],
    MAA: [16500, 12.990005, 80.169296],
    BLR: [16600, 13.1979, 77.706299],
    HYD: [16700, 17.231318, 78.429855],
    NAG: [16800, 21.092199, 79.047203],
    BBI: [16900, 20.244400024399997, 85.8178024292],
    CCU: [17000, 22.654699325561523, 88.44670104980469],
    AMD: [17100, 23.0772, 72.634697],
    BOM: [17200, 19.0886993408, 72.8678970337],
    PNQ: [17300, 18.5821, 73.919701],
    CNN: [17400, 11.918614, 75.547211],
    COK: [17500, 10.152, 76.401901],
    PAT: [17600, 25.591299, 85.087997],
    KNU: [17700, 26.404301, 80.410103],
    DEL: [17800, 28.55563, 77.09519],
    IXC: [17900, 30.6735, 76.788498],
    JSR: [18000, 23.1838, 89.160797],
    CGP: [18100, 22.249599, 91.813301],
    DAC: [18200, 23.843347, 90.397783],
    PBH: [18300, 27.4032, 89.424599],
    KTM: [18400, 27.6966, 85.3591],
    LHE: [18500, 31.521601, 74.403603],
    ISB: [18600, 33.549, 72.82566],
    KHI: [18700, 24.9065, 67.160797],
    TAS: [18800, 41.257900238, 69.2811965942],
    ALA: [18900, 43.354267, 77.042828],
    ULN: [19000, 47.843102, 106.766998],
    ICN: [19100, 37.46910095214844, 126.45099639892578],
    TYO: [19200, 35.764702, 140.386002],
    NRT: [19300, 35.764702, 140.386002],
    HND: [19400, 35.552299, 139.779999],
    ITM: [19500, 34.785499572753906, 135.43800354003906],
    KIX: [19600, 34.427299, 135.244003],
    FUK: [19700, 33.585899353027344, 130.4510040283203],
    OKA: [19800, 26.195801, 127.646004],
    GUM: [19900, 13.4834, 144.796005],
    CGY: [20000, 8.612203, 124.456496],
    CEB: [20100, 10.309261, 123.97974],
    MNL: [20200, 14.5086, 121.019997],
    BWN: [20300, 4.9442, 114.928001],
    SGN: [20400, 10.8188, 106.652],
    HAN: [20500, 21.221201, 105.806999],
    PNH: [20600, 11.5466, 104.844002],
    VTE: [20700, 17.988300323500003, 102.56300354],
    MFM: [20800, 22.149599, 113.592003],
    HKG: [20900, 22.308901, 113.915001],
    KHH: [21000, 22.577101, 120.349998],
    TPE: [21100, 25.0777, 121.233002],
    FOC: [21200, 25.934669, 119.66318],
    HYN: [21300, 28.562201, 121.429001],
    HGH: [21400, 30.23609, 120.428865],
    SHA: [21500, 31.198104, 121.33426],
    CZX: [21600, 31.919701, 119.778999],
    WHU: [21700, 31.3906, 118.408997],
    KHN: [21800, 28.864815, 115.90271],
    CGD: [21900, 28.9189, 111.639999],
    KWE: [22000, 26.541466, 106.803331],
    KMG: [22100, 25.110313, 102.936743],
    LHW: [22200, 36.515202, 103.620003],
    ZHY: [22300, 37.573125, 105.154454],
    SJW: [22400, 38.280701, 114.696999],
    PKX: [22500, 39.509945, 116.41092],
    BJS: [22600, 40.080101013183594, 116.58499908447266],
    TSN: [22700, 39.124401092499994, 117.346000671],
    TNA: [22800, 36.857201, 117.216003],
    TAO: [22900, 36.361953, 120.088171],
    HAK: [23000, 19.9349, 110.459],
    FUO: [23100, 23.0833, 113.07],
    ZGN: [23200, 23.392401, 113.299004],
    CAN: [23300, 23.392401, 113.299004],
    SZX: [23400, 22.639299, 113.810997],
    MDL: [23500, 21.702199935913086, 95.97789764404297],
    RGN: [23600, 16.907300949099998, 96.1332015991],
    CNX: [23700, 18.766799926799997, 98.962600708],
    BKK: [23800, 13.681099891662598, 100.74700164794922],
    URT: [23900, 9.13259983063, 99.135597229],
    KUL: [24000, 2.74558, 101.709999],
    JHB: [24100, 1.64131, 103.669998],
    QPG: [24200, 1.36042, 103.910004],
    SIN: [24300, 1.35019, 103.994003],
    CGK: [24400, -6.1255698204, 106.65599823],
    JOG: [24500, -7.78818, 110.431999],
    DPS: [24600, -8.74817, 115.167],
    DEX: [24700, -4.8557, 139.482006],
    PER: [24800, -31.94029998779297, 115.96700286865234],
    ADL: [24900, -34.947512, 138.533393],
    MEL: [25000, -37.673302, 144.843002],
    HBA: [25100, -42.836101532, 147.509994507],
    CBR: [25200, -35.3069, 149.195007],
    SYD: [25300, -33.94609832763672, 151.177001953125],
    BNE: [25400, -27.384199142456055, 153.11700439453125],
    CHC: [25500, -43.48939895629883, 172.53199768066406],
    WLG: [25600, -41.3272018433, 174.804992676],
    AKL: [25700, -37.01199, 174.786331],
    NOU: [25800, -22.014601, 166.212997],
    SUV: [25900, -18.04330062866211, 178.5590057373047],
    PPT: [26000, -17.553699, -149.606995],
    GDL: [26100, 20.52504, -103.301557],
    QRO: [26200, 20.6173, -100.185997],
    MEX: [26300, 19.435433, -99.082432],
    GUA: [26400, 14.5833, -90.527496],
    TGU: [26500, 14.0609, -87.217201],
    SJO: [26600, 9.99386, -84.208801],
    PTY: [26700, 9.0713596344, -79.3834991455],
    MDE: [26800, 6.16454, -75.4231],
    BOG: [26900, 4.70159, -74.1469],
    UIO: [27000, -0.125399, -78.354306],
    GYE: [27100, -2.15742, -79.883598],
    LIM: [27200, -12.0219, -77.114305],
    ARI: [27300, -18.348499, -70.338699],
    SCL: [27400, -33.393001556396484, -70.78579711914062],
    COR: [27500, -31.323601, -64.208],
    NQN: [27600, -38.949001, -68.155701],
    EZE: [27700, -34.8222, -58.5358],
    ASU: [27800, -25.240156, -57.519227],
    CGB: [27900, -15.6529, -56.116699],
    GYN: [28000, -16.632, -49.220699],
    BSB: [28100, -15.869167, -47.920834],
    UDI: [28200, -18.883579, -48.225936],
    SJP: [28300, -20.817113, -49.406963],
    RAO: [28400, -21.134314, -47.774053],
    VCP: [28500, -23.007404, -47.134502],
    SOD: [28600, -23.478001, -47.490002],
    GRU: [28700, -23.431944, -46.467778],
    QWJ: [28800, -23.431944, -46.467778],
    SJK: [28900, -23.2292, -45.8615],
    GIG: [29000, -22.809999, -43.250557],
    CNF: [29100, -19.63571, -43.966928],
    CAW: [29200, -21.698299, -41.301701],
    VIX: [29300, -20.258, -40.285],
    SSA: [29400, -12.908611, -38.322498],
    REC: [29500, -8.125984, -34.923316],
    JDO: [29600, -7.21932, -39.269096],
    FOR: [29700, -3.775833, -38.532222],
    BEL: [29800, -1.379279, -48.476207],
    MAO: [29900, -3.03861, -60.049702],
    POA: [30000, -29.994712, -51.166592],
    FLN: [30100, -27.670279, -48.552502],
    ITJ: [30200, -26.879431, -48.650979],
    NVT: [30300, -26.879431, -48.650979],
    BNU: [30400, -26.831661, -49.093569],
    JOI: [30500, -26.224501, -48.797401],
    CWB: [30600, -25.5285, -49.1758],
    CFC: [30700, -26.787423, -50.939942],
    XAP: [30800, -27.134199, -52.656601],
    PBM: [30900, 5.45283, -55.187801],
    GEO: [31000, 6.49855, -58.254101],
    BGI: [31100, 13.0746, -59.4925],
    GND: [31200, 12.0042, -61.786201],
    CUR: [31300, 12.1889, -68.959801],
    SDQ: [31400, 18.42970085144, -69.668899536133],
    STI: [31500, 19.406099319458008, -70.60469818115234],
    KIN: [31600, 17.935699462890625, -76.7874984741211],
    MIA: [31700, 25.79319953918457, -80.29060363769531],
    TPA: [31800, 27.975500106811523, -82.533203125],
    GNV: [31900, 29.6900997162, -82.2717971802],
    JAX: [32000, 30.49410057067871, -81.68789672851562],
    TLH: [32100, 30.3965, -84.350304],
    MGM: [32200, 32.300598, -86.393997],
    ATL: [32300, 33.6367, -84.428101],
    PDK: [32400, 33.8755989075, -84.3020019531],
    BNA: [32500, 36.1245002746582, -86.6781997680664],
    MEM: [32600, 35.04240036010742, -89.97669982910156],
    STL: [32700, 38.748697, -90.370003],
    IND: [32800, 39.7173, -86.294403],
    CHI: [32900, 41.9786, -87.9048],
    ORD: [33000, 41.9786, -87.9048],
    DTW: [33100, 42.212398529052734, -83.35340118408203],
    CLE: [33200, 41.411701, -81.8498],
    PIT: [33300, 40.49150085, -80.23290253],
    CMH: [33400, 39.998001, -82.891899],
    LCK: [33500, 39.813801, -82.927803],
    CLT: [33600, 35.2140007019043, -80.94309997558594],
    RDU: [33700, 35.877602, -78.787498],
    ORF: [33800, 36.8946, -76.201202],
    RIC: [33900, 37.50519943237305, -77.3197021484375],
    IAD: [34000, 38.9445, -77.455803],
    DCA: [34100, 38.8521, -77.037697],
    PHL: [34200, 39.87189865112305, -75.24109649658203],
    NYC: [34300, 40.639447, -73.779317],
};

const logger$1 = new Logger('fetchAirportCodeFromCdn');
const fetchHeader = async (url, header, timeout) => {
    const response = await withTimeout(fetch(url, {
        method: 'HEAD'
    }), timeout);
    return response.headers.get(header);
};
const fetchAirportCodeFromAmazon = async (url, timeout) => {
    const header = await fetchHeader(url, 'X-Amz-Cf-Pop', timeout);
    // parse airport code from the first 3 characters of X-Amz-Cf-Pop header
    if (!header || header.length < 3) {
        throw new Error('Could not get airport code from Amazon');
    }
    const airportCode = header.substring(0, 3);
    return airportCode;
};
const fetchAirportCodeFromFastly = async (timeout) => {
    const header = await fetchHeader('https://www.fastly.com', 'X-Served-By', timeout);
    // parse airport code from the last 3 characters of X-Served-By header
    if (!header || header.length < 3) {
        throw new Error('Could not get airport code from Fastly');
    }
    const airportCode = header.substring(header.length - 3);
    return airportCode;
};
const fetchAirportCodeFromCloudflare = async (timeout) => {
    const header = await fetchHeader('https://www.cloudflare.com', 'CF-RAY', timeout);
    // parse airport code from the last 3 characters of CF-RAY header
    if (!header || header.length < 3) {
        throw new Error('Could not get airport code from Cloudflare');
    }
    const airportCode = header.substring(header.length - 3);
    return airportCode;
};
const fetchAirportCodeFromCdn = async () => {
    const timeout = 2000;
    // try to get airport code from the first CDN that responds
    // if one fails, try the next one
    try {
        return await fetchAirportCodeFromAmazon('https://d47ahk2wrqweh.cloudfront.net/cdn-location', timeout);
    }
    catch (error) {
        logger$1.warn(error);
    }
    try {
        return await fetchAirportCodeFromFastly(timeout);
    }
    catch (error) {
        logger$1.warn(error);
    }
    try {
        return await fetchAirportCodeFromCloudflare(timeout);
    }
    catch (error) {
        logger$1.warn(error);
    }
    throw new Error('Could not get airport code from any CDN');
};

const DEFAULT_MAX_CACHE_AGE = 1000 * 60 * 60; // 1 hour
const logger = new Logger('getLocalRegion');
let cachedLocalRegion = undefined;
let cachedLocalRegionFetchTime = undefined;
const getLocalAirportCode = async () => {
    let airportCode;
    try {
        airportCode = await fetchAirportCodeFromCdn();
    }
    catch {
        return undefined;
    }
    return airportCode;
};
const getLocalAirportCodeByCoordinates = (latitude, longitude) => {
    const distances = [];
    Object.keys(airportCodeToRegion).forEach((key) => {
        const airport = airportCodeToRegion[key];
        const distance = haversine({ latitude, longitude }, { latitude: airport[1], longitude: airport[2] });
        distances.push([key, distance]);
    });
    // find the closest region
    distances.sort((a, b) => a[1] - b[1]);
    return distances[0][0];
};
const getRandomRegion = () => {
    // randomize the region form airpotCodeToRegionNumber
    const airportCodes = Object.keys(airportCodeToRegion);
    const randomAirportCode = airportCodes[Math.floor(Math.random() * airportCodes.length)];
    // indicate that the region is random by adding 99, the convention is
    // that random region numbers end with 99
    const randomRegion = airportCodeToRegion[randomAirportCode][0] + 99;
    logger.warn(`Could not get airport code, using random region: ${randomRegion}`);
    return randomRegion;
};
const getLocalRegionWithCache = async (maxCacheAge = DEFAULT_MAX_CACHE_AGE) => {
    if (cachedLocalRegion === undefined
        || cachedLocalRegionFetchTime === undefined
        || Date.now() - cachedLocalRegionFetchTime > maxCacheAge) {
        const region = await getLocalRegion();
        // eslint-disable-next-line require-atomic-updates
        cachedLocalRegion = region;
        // eslint-disable-next-line require-atomic-updates
        cachedLocalRegionFetchTime = Date.now();
        return region;
    }
    return cachedLocalRegion;
};
const getLocalRegion = async () => {
    let airportCode = undefined;
    airportCode = await getLocalAirportCode();
    if (airportCode === undefined || !airportCodeToRegion[airportCode]) {
        return getRandomRegion();
    }
    return airportCodeToRegion[airportCode][0];
};
const getLocalRegionByCoordinates = (latitude, longitude) => {
    const distances = [];
    Object.keys(airportCodeToRegion).forEach((key) => {
        const airport = airportCodeToRegion[key];
        const distance = haversine({ latitude, longitude }, { latitude: airport[1], longitude: airport[2] });
        distances.push([airport[0], distance]);
    });
    // find the closest region
    distances.sort((a, b) => a[1] - b[1]);
    return distances[0][0];
};

export { getLocalAirportCode, getLocalAirportCodeByCoordinates, getLocalRegion, getLocalRegionByCoordinates, getLocalRegionWithCache };
//# sourceMappingURL=exports.js.map
